(() => {
  // ==============================
  // Konfiguration: Felder -> URL-Param
  // ==============================
  const FIELD_IDS = [
    { id: 'x-input', param: 'text-x-achse-adjusted' },
    { id: 'y-input', param: 'text-y-achse-adjusted' },
    { id: 'rotation-input', param: 'text-rotate-adjusted' },
    { id: 'text-size-adjusted', param: 'text-size-adjusted' },

    { id: 'image-x-input', param: 'Motiv_x_achse_adjusted' },
    { id: 'image-y-input', param: 'Motiv_y_achse_adjusted' },
    { id: 'image-rotation-input', param: 'Motiv_rotation_adjusted' },
    { id: 'image-size-adjusted', param: 'Motiv_size_adjusted' },
  ];

  const WUNSCHTEXT_SELECTOR = 'input[name="properties[Wunschtext]"]';
  const PREVIEW_SELECTOR = 'input[name="properties[_Designer-Preview]"]';

  const RADIO_GROUPS = [
    'properties[Schriftart]',
    'properties[Schriftfarbe]',
    'properties[Dekofarbe-1]',
    'properties[Dekofarbe-2]',
    'properties[Motiv]',
  ];

  // Diese Felder werden bei Inkybay oft per JS gesetzt (ohne Events)
  // => Value-Property überwachen
  const WATCH_VALUE_PROPERTY_IDS = new Set([
    'x-input',
    'y-input',
    'rotation-input',
    'text-size-adjusted',
    'image-x-input',
    'image-y-input',
    'image-size-adjusted',
    'image-rotation-input',
  ]);

  // ==============================
  // Value Helper (robust)
  // ==============================
  function getCurrentValue(el) {
    if (!el) return '';
    let value = el.value;

    if (!value || value === '0' || value === '') value = el.getAttribute('value');
    if (!value || value === '0' || value === '') value = el.getAttribute('data-value');
    if (!value || value === '0' || value === '')
      value = el.dataset?.currentValue || el._currentValue;

    return (value ?? '').toString().trim();
  }

  // ==============================
  // Formdaten sammeln
  // ==============================
  function collectParams() {
    const data = {};

    FIELD_IDS.forEach(f => {
      const el = document.getElementById(f.id);
      const v = getCurrentValue(el);

      // Wie zuvor: leer / "0" ignorieren
      // (0px / 0deg bleibt drin, weil das nicht exakt "0" ist)
      if (v && v !== '0') data[f.param] = v;
    });

    const wunsch = document.querySelector(WUNSCHTEXT_SELECTOR);
    if (wunsch) {
      const v = getCurrentValue(wunsch);
      if (v) data['Wunschtext'] = v;
    }

    RADIO_GROUPS.forEach(groupName => {
      const checked = document.querySelector(`input[name="${groupName}"]:checked`);
      if (checked && checked.value) {
        const paramName = groupName.replace('properties[', '').replace(']', '');
        data[paramName] = checked.value;
      }
    });

    return data;
  }

  // ==============================
  // URL bauen: variant behalten
  // ==============================
  function buildUrlKeepingVariant(currentUrlString, paramsObj) {
    const current = new URL(currentUrlString, window.location.origin);
    const url = new URL(current.origin + current.pathname);

    const variant = current.searchParams.get('variant');
    if (variant) url.searchParams.set('variant', variant);

    Object.keys(paramsObj).forEach(k => url.searchParams.set(k, paramsObj[k]));
    return url.toString();
  }

  function updatePreviewUrlNow() {
    const previewInput = document.querySelector(PREVIEW_SELECTOR);
    if (!previewInput) return;

    const params = collectParams();
    previewInput.value = buildUrlKeepingVariant(previewInput.value, params);
  }

  // ==============================
  // Debounced Update (wichtig für korrekte Positionen)
  // ==============================
  let debounceTimer = null;
  function scheduleUpdate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      updatePreviewUrlNow();
    }, 100); // 80–150ms ist ideal; 100ms = stabil & schnell
  }

  // ==============================
  // Watcher: Attribute + Property
  // ==============================
  function observeAttributes(el) {
    if (!el) return;
    const obs = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.type === 'attributes' && (m.attributeName === 'value' || m.attributeName === 'data-value')) {
          scheduleUpdate();
          break;
        }
      }
    });
    obs.observe(el, { attributes: true, attributeFilter: ['value', 'data-value'] });
  }

  function observeValueProperty(el) {
    if (!el) return;
    let last = el.value;

    setInterval(() => {
      const now = el.value;
      if (now !== last) {
        last = now;
        scheduleUpdate();
      }
    }, 80);
  }

  // ==============================
  // Listener
  // ==============================
  function attachListeners() {
    FIELD_IDS.forEach(f => {
      const el = document.getElementById(f.id);
      if (!el) return;

      ['input', 'change', 'keyup', 'blur'].forEach(evt => el.addEventListener(evt, scheduleUpdate));

      observeAttributes(el);

      if (WATCH_VALUE_PROPERTY_IDS.has(f.id)) {
        observeValueProperty(el);
      }
    });

    const wunsch = document.querySelector(WUNSCHTEXT_SELECTOR);
    if (wunsch) {
      ['input', 'change', 'keyup', 'blur'].forEach(evt => wunsch.addEventListener(evt, scheduleUpdate));
      observeAttributes(wunsch);
    }

    RADIO_GROUPS.forEach(groupName => {
      document.querySelectorAll(`input[name="${groupName}"]`).forEach(r => {
        r.addEventListener('change', scheduleUpdate);
      });
    });
  }

  function init() {
    attachListeners();
    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Optional
  window.updatePreviewUrl = updatePreviewUrlNow;
  window.collectParams = collectParams;
})();